import * as React from "react";
import { TextField, Typography, Box } from "@mui/material";
import { Controller } from "react-hook-form";

export default function FormTextField({
  placeholder,
  fieldname,
  control,
  label,
  rules,
  multiline = false,
  rows = 3,
  textColor,
  required = false,
  disabled = false,
  defaultValue,
  onlyText = false,
  type = "text",
  size = "small",
}) {
  // Merge required rule if `required` prop is true
  const combinedRules = required
    ? { ...rules, required: `This field is required` }
    : rules;

  return (
    <Controller
      defaultValue={defaultValue || ""}
      name={fieldname}
      control={control}
      rules={combinedRules}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const handleInputChange = (event) => {
          const inputValue = event.target.value;
          if (type === "number") {
            if (inputValue === "") {
              onChange(""); // or you can set onChange(undefined) if appropriate for your use case
              return;
            }
            const numericValue = Number(inputValue);
            onChange(numericValue);
            return;
          }
          if (onlyText) {
            const filteredValue = inputValue.replace(/[^a-zA-Z\s]/g, "");
            const capitalizedValue =
              filteredValue.charAt(0).toUpperCase() + filteredValue.slice(1);
            onChange(capitalizedValue);
          } else {
            onChange(inputValue);
          }
        };

        return (
          <Box>
            {label && (
              <Typography
                variant="body1"
                textAlign={"left"}
                color={textColor && textColor}
              >
                {label} {required && <span style={{ color: "red" }}>*</span>}
              </Typography>
            )}

            <TextField
              fullWidth
              helperText={error ? error.message : null}
              error={!!error}
              onChange={handleInputChange}
              value={value}
              multiline={multiline}
              rows={rows}
              disabled={disabled}
              sx={{
                // "& input::placeholder": { fontSize: "14px" },
                "& .Mui-focused.MuiAutocomplete-input": {
                  color: "blue",
                },
              }}
              type={type}
              placeholder={placeholder}
              //   label={label && !labelOnTop ? label : null}
              size={size}
              variant="outlined"
            />
          </Box>
        );
      }}
    />
  );
}
